import { Box, styled } from '@ltvco/refresh-lib/theme';

export const ProfessionalToolCardRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2.25, 1.25),
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1.25),
  alignItems: 'flex-start',
  height: '100%',
  cursor: 'default',
}));

export const ProfessionalToolIconCircle = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  borderRadius: '100%',
  width: 48,
  height: 48,
  minWidth: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
